import NPVIcon from "../../assets/images/noi/npv.svg";
import NOIIcon from "../../assets/images/noi/noi.svg";
import ROIIcon from "../../assets/images/noi/roi.svg";
import BuildinValueIcon from "../../assets/images/noi/building-value.svg";

export const npvTotalData = {
  title: "NPV of Total Power Revenue",
  icon: NPVIcon,
  rows: [
    {
      label: "Your discount rate:",
      key: "discount_rate",
      value: "0",
      suffix: "%",
    },
    {
      label: "NPV of power revenue",
      key: "npv_power_revenue",
      value: "0",
    },
  ],
  chartData: {
    data: [
      {
        NPV_of_power_revenue: 0,
      },
    ],
    fields: [null, "NPV of power revenue"],
  },
};

export const noiIncreaseData = {
  title: "NOI Increase",
  icon: NOIIcon,
  defaultLabel: "Total new NOI",
  rows: [
    {
      label: "Existing NOI:",
      key: "existing_noi",
      value: "0",
      prefix: "$",
      suffix: "M",
    },
    {
      key: "power_revenue_noi",
      label: "Power revenue NOI:",
      value: "0",
    },
    {
      key: "total_new_noi",
      label: "Total new NOI",
      value: "0",
    },
    {
      key: "noi_increase",
      label: "NOI increase with power rev.",
      value: "0",
    },
  ],
  chartData: {
    data: [
      {
        power_revenue_NOI: 0,
        existing_NOI: 0,
      },
    ],
    fields: ["existing NOI", "power revenue NOI"],
  },
};

export const roiIncreaseData = {
  title: "ROI Increase",
  icon: ROIIcon,
  defaultLabel: "Total new ROI",
  rows: [
    {
      label: "Existing ROI:",
      key: "existing_roi",
      value: "0",
      suffix: "%",
    },
    {
      key: "power_revenue_roi",
      label: "Power revenue ROI:",
      value: "0",
    },
    {
      key: "total_new_roi",
      label: "Total new ROI:",
      value: "0",
    },
    {
      key: "roi_increase",
      label: "ROI increase with power rev:",
      value: "0",
    },
  ],
  chartData: {
    data: [
      {
        power_rev_ROI_increase: 0,
        existing_ROI: 0,
      },
    ],
    unit: "%",
    fields: ["existing ROI", "power rev ROI increase"],
  },
};

export const buildIncreaseData = {
  title: "Building Value Increase",
  icon: BuildinValueIcon,
  defaultLabel: "Power revenue NOI",
  rows: [
    {
      label: "Target cap rate:",
      key: "cap_rate",
      value: "0",
      suffix: "%",
    },
    {
      key: "power_revenue_noi",
      label: "Power revenue NOI:",
      value: "0",
    },
    {
      key: "power_revenue_contribution",
      label: "Power revenue value contribution:",
      value: "0",
    },
    {
      key: "building_value_increase",
      label: "Building value increase:",
      value: "0",
    },
  ],
  chartData: {
    data: [
      {
        power_revenue_value: 0,
        existing_building_value: 0,
      },
    ],
    fields: ["existing building value", "power revenue value"],
  },
};

export const parametersData = [
  {
    title: "Power Parameters",
    isOpen: false,
    sliders: [
      {
        label: "Sold electricity Margin",
        key: "sold_electricity_margin",
        value: 0,
        defaultValue: 0,
      },
      {
        label: "Purchased Electricity Margin",
        key: "purchased_electricity_margin",
        value: 0,
        defaultValue: 0,
      },
      {
        label: "PRaaS AI & Digitalization Impact Over Time",
        key: "digitalization_impact",
        value: 0,
        defaultValue: 0,
      },
      {
        label: "Gas prices",
        key: "gas_prices",
        value: 0,
        defaultValue: 0,
      },
    ],
  },
  {
    title: "Tenancy",
    isOpen: false,
    sliders: [
      {
        label: "Physical vacancy rate",
        key: "physical_vacancy_rate",
        value: 0,
        defaultValue: 0,
      },
      {
        label: "Economic vacancy rate",
        key: "economic_vacancy_rate",
        value: 0,
        defaultValue: 0,
      },
      {
        label: "Unconnected tenants",
        key: "unconnected_tenants",
        value: 0,
        defaultValue: 0,
      },
    ],
  },
  {
    title: "Power Assets",
    isOpen: false,
    unit: "kWh",
    sliders: [
      {
        label: "Installed batteries",
        key: "installed_batteries",
        value: 0,
        defaultValue: 0,
      },
      {
        label: "Installed Ev Charges",
        key: "installed_ev",
        value: 0,
        defaultValue: 0,
      },
      {
        label: "Installed solar sys.",
        key: "installed_solar",
        value: 0,
        defaultValue: 0,
      },
      {
        label: "Installed new power assets",
        key: "installed_new",
        value: 0,
        defaultValue: 0,
      },
    ],
  },
];

export const portfolioChartData = [
  {
    unit: "$",
    type: "npv",
    data: [
      {
        before: 0,
      },
    ],
  },
  {
    unit: "$",
    type: "noi",
    data: [
      {
        before: 0,
      },
    ],
  },
  {
    unit: "%",
    type: "roi",
    data: [
      {
        before: 0,
      },
    ],
  },
  {
    unit: "$",
    type: "building_value",
    data: [
      {
        before: 0,
      },
    ],
  },
];

export const detailedAnalysisChartData = [
  {
    unit: "$",
    data: [
      {
        before: 2000000,
      },
      {
        revised: 2200000,
      },
    ],
  },
  {
    unit: "%",
    data: [
      {
        before: 2,
      },
      {
        revised: "2.5",
      },
    ],
  },
  {
    unit: "$",
    data: [
      {
        before: 20000000,
      },
      {
        revised: 22000000,
      },
    ],
  },
  {
    unit: "%",
    data: [
      {
        before: 2,
      },
      {
        revised: "2.5",
      },
    ],
  },
];
